const nl = {
	common: {
		app_name: 'PubHubs',
		yivi: 'Yivi',
		loading: 'Laden ...',
		retry: 'Probeer opnieuw',
	},
	card: {
		description: 'Kaart uitgegeven met de volgende kenmerken:',
	},
	state: {
		hub_offline: 'Geen verbinding met deze hub. Wat je ziet is mogelijk niet actueel.',
		rooms_offline: 'Kamers kunnen worden getoond zodra er verbinding is.',
		room_offline: 'Deze kamer kan worden getoond zodra er verbinding is.',
		button_request: 'Verleen toegang',
		initial: 'Controleren of de hub client toegang heeft tot cookies en lokale opslag...',
		requesting: 'Toegang verlenen...',
		denied: 'Sorry, de hub client kan helaas niet worden uitgevoerd zonder toegang tot cookies en lokale opslag',
		woops: 'Oeps, ik had niet verwacht in deze status te zijn.',
		loading: 'Laden...',
		loading_message: 'Bericht laden...',
	},
	dialog: {
		ok: 'Ok',
		cancel: 'Annuleer',
		close: 'Sluiten',
		yes: 'Ja',
		no: 'Nee',
		hub_pin_title: 'Hub vastspelden',
		hub_unpin_title: 'Hub losmaken',
		hub_unpin_context: 'Wil je deze Hub losmaken?',
		submit: 'Bevestig',
		save: 'Opslaan',
		edit: 'Aanpassen',
		ignore: 'Negeren',
		continue: 'Verder',
		back: 'Terug',
		next: 'Volgende',
		previous: 'Vorige',
		title_sure: 'Weet je het zeker?',
		go_back: 'Ga terug',
	},
	errors: {
		needs_connection: 'Hiervoor is een internetverbinding nodig. Controleer je verbinding en probeer het opnieuw.',
		oops: 'OEPS!',
		error: 'Helaas, er is een fout opgetreden. <a href="https://www.pubhubs.net/nl/help/contact/" target="_blank" class="text-accent-primary">Neem contact op met de ontwikkelaars</a>.\n\n {0}',
		server: 'Serverfout',
		M_LIMIT_EXCEEDED: 'Te veel inlogpogingen achter elkaar. Probeer het over {0} seconden nog eens.',
		not_send_offline: 'Geen internetverbinding. Dit bericht is niet verzonden.',
		resend: 'Opnieuw verzenden',
		file_upload: 'Bestandsformaat wordt niet ondersteund',
		file_upload_failed: 'Bestand kon niet geüpload worden',
		file_upload_unsupported_type: 'Bestanden van het type {type} kunnen hier niet geüpload worden.',
		// Zie de opmerking bij deze sleutel in en.ts.
		file_upload_too_large: 'De server heeft dit bestand geweigerd omdat het te groot is ({size}). Probeer een kleiner bestand, of verklein het eerst.',
		file_upload_too_large_max: 'Dit bestand is {size}, meer dan het maximum van {max}.',
		file_upload_read_failed: 'Dit bestand kon niet van je apparaat gelezen worden. Mogelijk is het verplaatst of hernoemd, selecteer het opnieuw.',
		file_upload_network: 'Het bestand kon niet verzonden worden. Controleer je internetverbinding en probeer het nogmaals.',
		file_upload_rate_limited: 'Te veel uploads kort na elkaar. Wacht even en probeer het nogmaals.',
		file_upload_forbidden: 'Je mag hier geen bestanden uploaden. Probeer opnieuw in te loggen.',
		file_upload_server: 'De hub kon dit bestand nu niet accepteren (fout {status}). Probeer het later nogmaals.',
		file_upload_unknown: 'Het bestand kon niet geüpload worden (fout {status}). Probeer het nogmaals.',
		file_download: 'Dit bestand kon niet gedownload worden. Probeer het nogmaals.',
		file_share: 'Dit bestand kon niet in het gesprek gedeeld worden. Probeer het nogmaals.',
		no_valid_attribute: 'Een beveiligde kamer moet geldige attributen hebben',
		cant_find_room: 'Deze kamer is op het moment niet beschikbaar',
		admin_error: 'Je bent geen beheerder!',
		no_room_error: 'Gebruiker {0} is niet aangesloten bij een kamer in de hub.',
		// Zie de opmerkingen bij deze sleutels in en.ts.
		account_does_not_exist: 'We konden hier geen PubHubs-account bij vinden. Heb je nog geen account, registreer er dan een.',
		attribute_banned: 'Het volgende attribuut is verbannen en kan niet in PubHubs worden gebruikt: {0}.',
		banned: 'Dit account is verbannen en kan niet langer worden gebruikt om in te loggen bij PubHubs.',
		attribute_already_taken: 'Het volgende attribuut is al gekoppeld aan een PubHubs account: {0}. Probeer in te loggen.',
		general_error:
			'Helaas is er een fout opgetreden. Probeer het opnieuw en <a href="https://www.pubhubs.net/nl/help/contact/" target="_blank" class="text-accent-primary">neem contact op met de ontwikkelaars</a> als het probleem blijft bestaan.',
		retry_with_new_attr: 'Je gegevens konden niet worden geverifieerd, mogelijk zijn ze verlopen. Probeer het opnieuw.',
		no_hubs_found:
			'Helaas konden we geen hubs tonen. Probeer het later opnieuw en <a href="https://www.pubhubs.net/nl/help/contact/" target="_blank" class="text-accent-primary">neem contact op met de ontwikkelaars</a> als het probleem blijft bestaan.',
		cant_find: 'Sorry, we konden de pagina of kamer die u zocht niet vinden.',
		notid_attribute_already_taken:
			'Je hebt het telefoonnummer al voor een ander account gebruikt, wil je toch een nieuw account aanmaken klik dan op ok en probeer het opnieuw',
		notid_taken_title: 'Telefoonnummer is al in gebruik',
		YiviServerGone:
			'U kon waarschijnlijk niet volledig inloggen omdat battery-saver javascript blokeerd, probeer de laatste stap nog een keer om de inlog the voltooien.',
		// Zie de opmerkingen bij deze sleutels in en.ts.
		yivi_session_failed: 'Er is iets misgegaan in de Yivi-app, waardoor we je niet konden inloggen. Probeer het opnieuw.',
		card_not_added:
			'Je bent ingelogd, maar je PubHubs-kaart is niet aan je Yivi-app toegevoegd. Je hebt deze nodig om de volgende keer in te loggen, dus rond de laatste stap nog even af.',
		card_not_linked:
			'Je bent ingelogd, maar je PubHubs-kaart kon niet aan je account worden gekoppeld. Je hebt deze nodig om de volgende keer in te loggen, dus probeer de laatste stap nog een keer.',
	},
	file: {
		upload: 'Upload',
		file: 'Bestand',
		upload_file: 'Bestand uploaden',
		upload_files: 'Bestanden uploaden',
		upload_message: 'Wil je dit uploaden?',
		remove_all_files: 'Verwijder bestanden',
		upload_error: 'Fout tijdens uploaden, probeer nogmaals',
		from_library: 'Uit bestanden',
	},
	forms: {
		next: 'Volgende stap',
		skip: 'Overslaan',
		back: 'Terug',
		submit: 'Indienen',
		save: 'Opslaan',
	},
	home: {
		hub_homepage_welcome: 'Welkom bij de {0}-hub!',
		hub_homepage_join: 'Doe mee met deze hub',
		hub_homepage_welcome_auth: 'Welkom bij de {0}-hub.',
		welcome: 'Welkom',
		highlighted_hubs: 'Uitgelichte hubs',
		welcome_to: '{0} overzicht van Hubs',
		hub_card_about: 'Over',
		heading: 'Hub beschrijving:',
		contact_details: 'Contactgegevens:',
		enter_hub: 'Ga naar {hub}',
		hubs_overview: 'Hubsoverzicht',
		pinned: 'Vastgespeld',
		discover: 'Ontdekken',
		add_hub: 'Hub toevoegen',
		add_hub_description: 'Ontdek hubs en speld je eerste hub vast.',
		pinned_all_hubs: 'Je hebt alle hubs al vastgespeld',
		no_hubs_available: 'Er zijn geen hubs beschikbaar',
		load_hubs_failed: 'De hubs konden niet worden geladen.',
	},
	about: {
		title: 'Over PubHubs',
		version: 'Versie {0}',
		description: 'PubHubs is een publiek, privacyvriendelijk en open-source community-netwerk.',
		help_button: 'Naar de help-pagina',
	},
	mss: {
		system_offline: 'Systeem offline',
		system_offline_description:
			'Ons systeem is nu offline, dus niet alles werkt zoals verwacht.\nProbeer het later opnieuw. <a href="https://www.pubhubs.net/nl/help/contact/" target="_blank" class="text-accent-primary">Neem contact op met de ontwikkelaars</a> als het probleem blijft bestaan.',
	},
	register: {
		have_account: 'Heb je al een {0} account?',
		no_account_yet: 'Nog geen {0} account?',
		register_3_steps: 'Registreer bij {0} in 3 stappen!',
		card_1_title: 'Veilig registreren met {0}',
		card_1_text_1: 'Voor het inloggen en registreren maakt {0} gebruik van een aparte app: {1}',
		card_1_yivi: 'Wat is {0}?',
		card_1_yivi_text: '{0} is een identiteitsapp waarmee je makkelijk en veilig inlogt, zonder dat je te veel over jezelf deelt.',

		card_2_title: 'Voeg je e-mail en telefoonnummer toe aan {0}',
		card_2_text_1: 'Volg de stappen in de {0} app. Voeg daarna je telefoonnummer toe.',
		card_2_text_2: 'Deze gegevens heeft {0} alleen voor registratie nodig.',

		card_3_title: 'Scan de QR-code',
		// The _app variants are shown on a device that opens the Yivi app by link, where there is no
		// QR code to scan.
		card_3_title_app: 'Open de {0}-app',
		card_3_text_2: 'Scan de QR-code met je {0} app en deel je gegevens om in te loggen op {1}.',
		card_3_text_2_app: 'Open je {0} app en deel je gegevens om in te loggen op {1}.',
		// The success variants are shown once the disclosure succeeded and the card is being issued.
		card_3_success_title: 'Je bent ingelogd!',
		card_3_success_text: 'Scan de {0} QR code nog een keer om je {1} kaart toe te voegen.',
		card_3_success_text_app: 'Open je {0} app nog een keer om je {1} kaart toe te voegen.',
		card_3_success_text_chained: 'Voeg je {1} kaart toe in de {0} app die je net gebruikt hebt om af te ronden.',

		card_1_alt: 'Laptop',
		card_2_alt: '{0}-mascotte met kenmerken',

		video_click_to_play: 'Klik om video af te spelen',
		video_hosted_by_vimeo: 'Deze video wordt gehost door Vimeo',

		yivi_explained: '{0} uitgelegd in 1,5 minuut',
		yivi_faq: 'Veelgestelde vragen',
		yivi_faq_1_question: 'Wat is Yivi?',
		yivi_faq_1_answer:
			'Yivi is een identiteitsapp waarmee je veilig kunt inloggen en gegevens kunt delen zonder te veel persoonlijke informatie vrij te geven.',
		yivi_faq_2_question: 'Hoe werkt Yivi?',
		yivi_faq_2_answer:
			'Yivi gebruikt attributen die je kunt tonen wanneer een website of app dat nodig heeft, zonder dat je alles over jezelf hoeft te delen.',
		yivi_faq_3_question: 'Waarom gebruikt PubHubs Yivi?',
		yivi_faq_3_answer: 'PubHubs gebruikt Yivi om jouw identiteit veilig te verifiëren en privacy te garanderen.',
		yivi_faq_4_question: 'Hoe voeg ik gegevens toe aan Yivi?',
		yivi_faq_4_answer:
			'Je kunt via de Yivi-app persoonlijke gegevens toevoegen door ze op te halen van betrouwbare bronnen zoals de overheid of je werkgever.',
		yivi_faq_5_question: 'Waarom heeft PubHubs mijn e-mail adres en telefoonnummer nodig?',
		yivi_faq_5_answer: 'Deze gegevens zijn nodig om je te kunnen garanderen dat je een uniek individu bent.',

		register: 'Registreren',
		register_with: 'Registreren met {0}',
		welcome: 'Welkom, doe mee met PubHubs!',
		use_yivi: 'Voor het registreren en inloggen maak je gebruik van de Yivi app.',
		start_registration: 'Je begint hier met registreren, in 3 stappen.',
		overview_step1: 'Download de Yivi app — als je die nog niet hebt',
		overview_step2: 'Voeg je gegevens toe aan de Yivi app',
		overview_step3: 'Scan de QR code met de Yivi app',
		yivi_downloaded: 'Heb je de Yivi app al?',
		yivi_no: 'Nee \xa0\xa0ik heb de Yivi app niet',
		yivi_yes: 'Ja \xa0\xa0ik heb de Yivi app',
		skip_step1: 'Sla stap 1 over',
		step_go_to: 'Ga naar stap {0}',
		step_previous: 'Terug naar de vorige stap',
		install_yivi: 'Installeer de Yivi app.',
		yivi_what: 'Wat is Yivi?',
		yivi_short_description: 'Een app waarmee je makkelijk en veilig bewijst wie je bent.',
		yivi_download: 'Download de Yivi app en volg de instructies in de app.',
		yivi_installed: 'Ik heb de Yivi app geïnstalleerd',
		more: 'Meer weten?',
		yivi_workings: 'Hoe werkt Yivi?',
		yivi_workings_answer:
			'Yivi is een app voor je digitale identiteit. Je kunt met Yivi gegevens over jezelf delen, zoals je naam, adres, leeftijd, telefoonnummer en e-mailadres. Je deelt alleen de gegevens die in een situatie nodig zijn. Je kunt Yivi gebruiken om in te loggen op verschillende websites en jezelf daar bekend te maken.\n\nOm Yivi te gebruiken, moet je eerst gegevens over jezelf in de app toevoegen. De app legt uit hoe je dit doet. Voor meer informatie, zie de website {hyperlink}. Om Yivi voor PubHubs te gebruiken, moet je een e-mailadres en telefoonnummer in de app toevoegen.',
		yivi_why: 'Waarom Yivi voor PubHubs?',
		yivi_why_answer:
			'Binnen PubHubs wordt Yivi voor twee dingen gebruikt. {reasons} Yivi is net als PubHubs privacy-vriendelijk en open over hoe het werkt, via open source software. Yivi is een losse app, die door PubHubs gebruikt wordt, maar geen onderdeel is van PubHubs. Yivi wordt ook op andere websites gebruikt om in te loggen.',
		yivi_why_central_login:
			'Voor centrale login. Je deelt dan je e-mailadres en je mobiele nummer. Die gegevens zijn alleen bij de centrale login bekend en niet in de verschillende hubs die je bezoekt. Jouw gegevens worden niet met anderen gedeeld.',
		yivi_why_room_login:
			'Om in te loggen in sommige Kamers, waar meer informatie gevraagd wordt over de deelnemers. Dat kan bijvoorbeeld gebeuren bij een Kamer voor de mensen in je buurt, waar je eerst moet bewijzen wat je postcode is om erin te komen. Ook kan het voorkomen dat je moet bewijzen dat je e-mailadres op een lijst staat voor een bepaalde Kamer, voordat je binnen kan.',
		yivi_link: 'https://yivi.app/',
		data_request: 'PubHubs vraagt om een e-mailadres en mobiel nummer, alleen voor registratie.',
		data_add: 'Voeg je e-mailadres en mobiele nummer toe in de Yivi app.',
		data_add_how: 'Hoe voeg ik deze gegevens toe?',
		data_add_how_answer:
			"In de Yivi app staat een knop waarmee je persoonlijke gegevens kunt ophalen en in de app kunt opslaan. Voor PubHubs moet je een e-mailadres en een mobiel nummer in je Yivi app toevoegen. Je kunt meerdere e-mailadressen en nummers toevoegen. Je kunt dan kiezen welke je wil gebruiken voor aanmelding bij PubHubs.\n\n Op zo'n manier kun je, als je dat wil, twee verschillende accounts voor PubHubs hebben: een privé account, met je privé e-mail en mobiele nummer, en eentje voor je werk, met je werk e-mail en nummer.",
		data_why: 'Waarom heeft PubHubs mijn e-mail en nummer nodig?',
		data_why_answer:
			'PubHubs gebuikt de combinatie van jouw e-mail en mobiele nummer om jou te herkennen. De gegevens worden niet gebruikt om contact met je op te nemen. Als je een nieuwe telefoon hebt, moet je jezelf opnieuw bij PubHubs registreren. Gebruik dan bij het registreren je e-mailadres en mobiele nummer waarmee je eerder inlogde. Dan herkent PubHubs je en kun je verder met je eerdere gesprekken.',
		data_added: 'Ik heb deze gegevens nu toegevoegd',
		data_share: 'Deel je e-mail en mobiele nummer in de app',
		add_registration: 'Voeg je PubHubs registratie toe in de app',
		rewards: {
			good_job: 'Goed bezig!',
			almost_done: 'Top, je bent bijna klaar!',
			hooray: 'Hoera! {0} Je bent geregistreerd en ingelogd bij PubHubs.\nJe wordt vanzelf doorgestuurd naar een overzicht met hubs. Veel plezier!',
		},
		inapp: {
			in_yivi: 'Waarschijnlijk bekijkt u deze pagina vanuit de Yivi app.',
			reobtain_not_possible: 'Het is vanuit daar momenteel niet mogelijk een PubHubs kaartje te krijgen.',
			go_to_pubhubs_directly: 'Ga in plaats daarvan naar de PubHubs wesbite en (her)registreer.',
			youll_get_card: 'Tijdens dit proces krijgt u een nieuwe PubHubs kaart.',
		},
	},
	login: {
		login: 'Login',
		mascot_alt: '{0}-mascotte',
		login_again: 'Je bent uitgelogd. Log opnieuw in om verder te gaan.',
		loading_yivi: 'Yivi laden...',
		yivi_app_missing: 'De Yivi app kon niet worden geopend. Controleer of de app geïnstalleerd is en probeer het opnieuw.',
	},
	review_mode: {
		enter_title: 'Overschakelen naar de review-omgeving?',
		enter_text:
			'Dit is bedoeld voor app store-reviewers. PubHubs gebruikt dan een aparte testomgeving, waar je je registreert met demogegevens van Yivi. Op de inlogpagina kun je weer terugschakelen.',
		label: 'Review-omgeving',
		leave: 'Verlaten',
	},
	logout: {
		logout: 'Logout',
		logout_sure: 'Weet je zeker dat je PubHubs wilt verlaten?',
	},
	pwa: {
		add_app: 'Voeg PubHubs toe als app',
		click_menu: 'Klik op het menu',
		add_to_homescreen: 'Klik op "Toevoegen aan startscherm"',
		add_page_to: 'Klik op "Pagina toevoegen aan" en kies "Startscherm"',
		add_to: 'Klik op "Toevoegen aan..." en kies "Startscherm"',
		add_to_phone: 'Klik op "Aan telefoon toevoegen"',
		add_manually: 'Handmatig toevoegen:',
		install: 'Installeren',
		click_share: 'Klik op "Delen"',
		ios_add_to_homescreen: 'Veeg omhoog en klik "Zet op beginscherm"',
		do_not_show_again: 'Laat niet meer zien op dit apparaat*',
		find_instructions: '* Je kunt deze uitleg opnieuw bekijken in de instellingen.',
		open_instructions: 'Bekijk uitleg',
	},
	menu: {
		calender: 'Kalender',
		contact: 'Admin Contact',
		copy_hub_url: 'Kopieer hub-url',
		copy_room_url: 'Kopieer kamer-url',
		enter_room: 'Ga naar kamer',
		leave_room: 'Verlaat kamer',
		leave_conversation: 'Verlaat gesprek',
		download_file: 'Downloaden',
		hide_message: 'verberg bericht',
		show_message: 'toon bericht',
		copy_image: 'Afbeelding kopiëren',
		save_image: 'Afbeelding opslaan',
		home: 'Hub welkom',
		directmsg: 'Directe berichten',
		discover: 'Ontdek kamers',
		logout: 'Uitloggen',
		name: 'Hier komt een naam',
		private_rooms: '@:rooms.private_rooms',
		group_rooms: 'Groepsruimtes',
		admin_contact: 'Administratieve contactruimtes',
		rooms: '@:rooms.rooms',
		settings: 'Instellingen',
		tool: 'Functie',
		admin_tools: 'Beheerders',
		admin_tools_rooms: 'Beheer kamers',
		admin_tools_room: 'Beheer kamer: {0}',
		admin_tools_users: 'Beheer gebruikers',
		admin_tools_hub_settings: 'Hub instellingen',
		admin_tools_roles: 'Rollen',
		back_to_rooms: 'Terug naar kamers',
		close_admin_menu: 'Sluit beheerdersmenu',
		overview: 'Overzicht',
		moderation: 'Moderatie',
		manage: 'Beheer',
		admin_dashboard: 'Beheerdersdashboard',
		steward_dashboard: 'Stewarddashboard',
		reports: 'Rapporten',
		audit_log: 'Audit log',
		add_reaction: 'Reactie toevoegen',
		copy_message: 'Bericht kopiëren',
		edit_message: 'Bericht aanpassen',
		delete_message: 'Verwijder bericht',
		direct_message: 'Direct bericht',
		whisper: 'Fluisteren',
		join_room: 'Deelnemen',
		reply: 'Beantwoorden',
		reply_in_thread: 'Beantwoorden in thread',
	},
	others: {
		step: 'Stap {0}',
		nop: 'Deze functionaliteit is nog niet geimplementeerd.',
		search: 'Zoeken',
		search_rooms: 'Zoek naar kamers',
		search_hubs: 'Zoek naar hubs',
		search_users: 'Zoek naar gebruikers',
		search_rooms_not_found: 'Geen kamers gevonden',
		search_room: 'Zoek in deze kamer',
		search_room_hint: 'Voer een zoekterm in en druk op Enter om berichten in deze kamer te zoeken.',
		search_conversation: 'Zoek in dit gesprek',
		room_members: 'Leden',
		searching: 'Bezig met zoeken...',
		search_nothing_found: 'Niets gevonden',
		clear_search: 'Zoekopdracht wissen',
		search_found_items: 'Aantal gevonden items:',
		empty_users: 'Geen gebruikers om te beheren',
		read_receipt: 'Gelezen door',
		new_message: 'Nieuw gesprek',
		join_room_to_dm: 'Geen gebruikers gevonden. Betreed eerst een kamer om met andere mensen te praten.',
		new_group: 'Nieuwe groep',
		group_select: 'Selecteer maximaal 5 mensen',
		next: 'volgende',
		select_group_name: 'Selecteer goepsnaam',
		group_name: 'Groepsnaam',
		group_members: 'groepsleden',
		typing: 'Begin te typen ...',
		load_more_results: 'Laad meer resultaten',
		help: 'Loop je vast met PubHubs?',
		work_in_progress: 'PubHubs is nog in ontwikkeling. We zijn nog bezig met het maken van een handleiding. Stel je vraag voorlopig in een van de kamers.',
		no_private_message: 'Het is hier nog wat stil. Laten we iets nieuws beginnen! Tik gewoon op het +-icoon om je eerste gesprek te starten.',
		select_conversation: 'Selecteer een gesprek om te beginnen met berichten',
		open_conversation: 'Open gesprek met {name}',
		start_new_conversation: 'Start een nieuw gesprek met de + knop',
		filter_users: 'filter',
		filter_values: 'Type om te zoeken',
		deselect: 'Deselecteren',
		clear_selection: 'Selectie wissen',
		toggle_options: 'Opties tonen',
		select_value: 'selecteer een waarde',
		userId: 'Gebruikers-ID',
		page_x_of_y: 'Pagina {0} van {1}',
	},
	hubs: {
		under_construction: 'Deze hub is in onderhoud',
	},
	rooms: {
		room: 'Kamer',
		thread: 'Thread',
		me: 'Ik',
		just_you: 'Alleen jij',
		join_sure: 'Wil je deelnemen aan deze kamer?',
		leave_sure: 'Weet je zeker dat je deze kamer wilt verlaten?',
		leave_admin: 'Waarschuwing: je bent de enige beheerder in de kamer. Als je de kamer velaat zal deze geen beheerder meer hebben.',
		leave_only_admin: 'Waarschuwing: je bent de maker van de kamer en het enige lid van de kamer. Al je weggaat, wordt de kamer verwijderd.',
		group_limit: 'Je kunt geen gebruikers meer aan de groep toevoegen.',
		leave_dm_sure: 'Weet je zeker dat je dit gesprek wilt verlaten? Je verliest toegang tot de berichtgeschiedenis.',
		try_again: 'Kan niet deelnemen aan kamer. Probeer het opnieuw.',
		new_message: 'Bericht',
		members: 'leden',
		member: 'lid',
		private_room: 'Privé kamer',
		private_members: 'Met ',
		private_rooms: 'Privé kamers',
		private_topic: 'Een gesprek tussen',
		private_add: 'Nieuwe privé kamer',
		private_search_user: 'Zoek persoon',
		rooms: 'Kamers',
		join_room: 'Neem deel',
		already_joined: 'Betreed kamer',
		view_access_requirements: 'Bekijk eisen',
		close_access_requirements: 'Sluit eisen',
		join_secured_room: 'Betreed kamer',
		join_secured_room_dialog: 'Neem deel aan de beveiligde kamer met Yivi.',
		joined: 'Successvol lid geworden van deze kamer!',
		add_room: 'Voeg kamer toe',
		name: 'Naam van kamer',
		contact: 'Steward voor kamer ',
		name_general_room: 'Algemeen',
		name_feedback_room: 'Je feedback over PubHubs',
		no_match: 'Er zijn geen kamers gevonden die aan je zoekopdracht voldoen.',
		filter: 'Filter kamers',
		title: '{0}',
		access_denied: 'Toegang geweigerd',
		secure_room_message_heading: 'Voordat je verder kan gaan naar de kamer',
		secure_room_message: 'Scan de QR-code met je Yivi-app om toegang te krijgen.',
		display_qr: 'Toon QR-code',
		incorrect_attributes:
			'De gegevens die je hebt gedeeld geven je geen toegang tot deze kamer. Controleer of je de juiste gegevens in je Yivi-app hebt gebruikt en probeer het opnieuw.',
		required_attributes:
			'Dit is een beveiligde kamer. Scan de QR-code hieronder met je Yivi-app om deel te nemen. Je deelt alleen de volgende gegevens met de kamer, niets anders:',
		secure_room_enter_info: 'De volgende gegevens zijn nodig:',
		secured_room_error: 'Het lijkt erop dat je geen toegang hebt tot deze kamer! Controleer of je de juiste gegevens met de Yivi-app hebt laten zien.',
		secured_room_attributes_edit_error: 'Voeg minimaal één waarde per attribuut toe',
		unavailable: 'Er zijn geen kamers beschikbaar om aan deel te nemen',
		admin_badge: 'Beheerder',
		member_count: 'Aantal leden',
		yivi_attributes: 'Yivi attributen',
		room_type_prefix_public: 'openbare',
		room_type_prefix_secured: 'beveiligde',
		room_type_suffix_default: 'kamer',
		room_type_suffix_forum: 'forum kamer',
		upload_error: 'Fout tijdens uploaden',
		upload_not_allowed: 'Dit bestandstype is niet toegestaan.',
		empty_rooms: 'Geen kamers om te beheren',
		latest_news: 'Laatste nieuws',
		more_news: 'Meer nieuws',
		more_suggestions: 'Meer suggesties',
		popular_rooms: 'Populaire kamers en discussies',
		watch: 'Kijk',
		read: 'Lees',
		event: 'Evenement',
		discussion: 'Discussie',
		roomCreated: 'Kamer aangemaakt',
		no_messages_yet: 'Er zijn nog geen berichten in deze kamer',
		preview_image: 'Afbeelding',
		preview_file: 'Bestand',
		preview_poll: 'Poll',
		preview_signed: 'Ondertekend bericht',
		preview_unknown: 'Stuurde een bericht',
		discover: 'Ontdek kamers',
		room_library: 'Bibliotheek voor kamer:',
		no_rooms_found: 'Geen kamers gevonden',
		load_failed: 'De kamers konden niet worden geladen.',
		unread_messages: 'Ongelezen berichten',
		last_read_message: 'Laatst gelezen',
		one_new_message: '1 nieuw bericht',
		new_messages: '{count} nieuwe berichten',
		scroll_to_new_messages: 'Scroll naar {count} nieuwe berichten',
		jump_to_bottom: 'Ga naar beneden',
		jump_to_unread_thread: 'Ongelezen thread',
		loading_older_messages: 'Oudere berichten laden...',
		loading_newer_messages: 'Nieuwere berichten laden...',
		announcement: 'aankondiging',
		steward: 'steward',
		stewards: 'stewards',
		experts: 'experts',
		steward_support: 'Steward Contact',
		contact_steward_title: 'Contact kamersteward',
		contact_steward_subtitle: 'Voor kamergerelateerde vragen',
		memberlist: 'Leden',
		profile_public_rooms: 'Gedeelde openbare kamers',
		profile_shared_secured_rooms: 'Gedeelde beveiligde kamers',
		administrator: 'beheerder',
		votes: 'stemmen',
	},
	settings: {
		profile_title: 'Jouw profiel',
		edit_profile: 'Profiel bewerken',
		change_avatar: 'Foto aanpassen',
		remove_avatar: 'Foto verwijderen',
		confirm_remove_avatar: 'Weet je zeker dat je je profielfoto wilt verwijderen?',
		userId_description: 'Dit is je unieke ID voor deze hub. Je kunt dit niet wijzigen.',
		userId: 'Unieke hub ID',
		displayname: 'Gekozen naam',
		avatar: 'Foto',
		displayname_changed: 'Naam gewijzigd naar `{0}`.',
		avatar_changed: 'Foto bijgewerkt.',
		theme: 'Kleurenschema',
		theme_changed: 'Kleurenschema gewijzigd in `{0}`.',
		timeformat: 'Tijdnotatie',
		language: 'Taal',
		language_changed: 'Taal gewijzigd in `{0}`.',
		title: 'Instellingen',
		notifications: 'Meldingen',
	},
	hub_settings: {
		heading: 'Hub instellingen',
		icon_heading: 'Hub icoon',
		icon_description: 'Een publiekelijk zichtbare afbeelding voor deze hub. Gebruik een PNG-, JPEG- of SVG-bestand, max 5 MB.',
		save: 'Opslaan',
		settings_saved: 'Veranderingen opgeslagen.',
		error_saving_icon: 'Kon het hublogo niet opslaan. Probeer het later opnieuw.',
		error_saving_banner: 'Kon de hubbanner niet opslaan. Probeer het later opnieuw.',
		file_format_not_allowed: 'Bestandstype niet toegestaan. Gebruik .png, .jpeg, .jpg of .svg bestanden.',
		file_too_large: 'Bestand te groot (max 5 MB). Gebruik een kleiner bestand.',
		description_heading: 'Hubbeschrijving',
		description_description: `Kies een heldere en korte beschrijving van het onderwep en de doelgroep van deze hub. Deze beschrijving wordt weergegeven op de 'Hub welkom' pagina binnen de hub.`,
		description: 'De hub is voor .... De doelgroep van de hub omvat ....',
		banner_heading: 'Hubbanner',
		banner_description: 'Een publiekelijk zichtbare bannerafbeelding voor deze hub (468x85)px. Gebruik een PNG-, JPEG- of SVG-bestand, max 5 MB.',
		summary_heading: 'Hubsamenvatting',
		summary_description: `Deze omschrijving komt op de centrale 'Ontdek hubs' pagina onder de hub naam en is doorzoekbaar.`,
		summary: 'Online community / platform voor ....',
		contact_heading: 'Contactgegevens hub',
		contact_description: 'Contactgegevens van de eigenaren van de hub.',
		contact: 'Jouw e-mailadres',
		consent_heading: 'Hub huisregels',
		consent_description: 'De huisregels die iedere user in de hub moet accepteren om binnen te komen.',
		consent: 'Vul hier de huisregels van de hub in',
	},
	admin: {
		title: 'Beheerder',
		manage_room_description: 'Aanmaken, aanpassen en verwijderen van (beveiligde) kamers',
		manage_user_description: 'Zoek en beheer gebruikers',
		add_room: 'Voeg een openbare kamer toe',
		add_secured_room: 'Voeg een beveiligde kamer toe',
		name: 'Naam',
		name_placeholder: 'Naam van de kamer',
		topic: 'Omschrijving',
		topic_placeholder: 'Omschrijving van het kamer thema',
		public_room: 'Openbare kamer',
		public_rooms: 'Openbare kamers',
		secured_room: 'Beveiligde kamer',
		secured_rooms: 'Beveiligde kamers',
		secured_rooms_tooltip: 'Om toegang te krijgen tot beveiligde kamers, moeten gebruikers bepaalde gegevens delen via de Yivi app.',
		room_type: 'Type kamer',
		room_type_placeholder: 'Normale kamer',
		room_type_forum: 'Forum kamer',
		room_type_locked: 'Het type kamer kan niet worden gewijzigd nadat de kamer is aangemaakt.',
		edit_name: 'Pas naam van kamer aan',
		room_category: 'Kamercategorie',
		room_details: 'Kamerdetails',
		user_details: 'Gebruikersdetails',
		report_details: 'Meldingsdetails',
		select_room_placeholder: 'Selecteer een kamer uit de lijst voor meer details',
		select_user_placeholder: 'Selecteer een gebruiker uit de lijst voor meer details',
		select_report_placeholder: 'Selecteer een melding uit de lijst voor meer details',
		filter_reports: 'Filter meldingen',
		empty_reports: 'Geen meldingen gevonden',
		reported_message: 'Bericht',
		report_room: 'Kamer',
		report_sender: 'Gemelde gebruiker',
		report_reporter: 'Gemeld door',
		report_reason: 'Reden',
		report_score: 'Score',
		report_time: 'Tijd',
		report_event_id: 'Event ID',
		preview_message: 'Bekijk bericht',
		message_preview: 'Berichtvoorbeeld',
		message_type_image: '[Afbeelding]',
		message_type_file: '[Bestand]',
		message_content_unavailable: 'Berichtinhoud niet beschikbaar',
		message_not_found: 'Bericht niet gevonden',
		go_to_message: 'Ga naar bericht',
		report_from: 'Gerapporteerd door',
		report_against: 'Tegen',
		no_reason: 'Geen reden opgegeven',
		no_score: 'Geen score',
		delete_report: 'Verwijder melding',
		delete_report_confirm: 'Weet je zeker dat je deze melding wilt verwijderen?',
		load_more_reports: 'Meer laden ({loaded} van {total})',
		reports_since: 'Sinds {0}',
		load_older: 'Ouder laden',
		message: 'Bericht',
		report: 'rapport',
		reports: 'rapporten',
		go_to_room: 'Ga naar kamer',
		edit_room: 'Bewerk kamer',
		edit_secured_room: 'Pas beveiligde kamer aan',
		remove_room: 'Verwijder kamer',
		upgrade_to_steward: 'Promoveer tot steward',
		added_room: 'kamer toegevoegd',
		no_rooms: 'Geen kamers',
		remove_room_sure: 'Weet je zeker dat je deze openbare kamer wilt verwijderen?',
		no_secured_rooms: 'Geen beveiligde kamers',
		secured_remove_sure: 'Weet je zeker dat je deze beveiligde kamer wilt verwijderen?',
		secured_description: 'Attribuut Omschrijving',
		secured_description_placeholder: 'Omschrijving van de benodigde gegevens om je bij de kamer aan te sluiten',
		expiration_days: 'Verlooptijd (dagen)',
		expiration_days_placeholder: 'Aantal dagen voordat gebruikers opnieuw moeten inloggen (1-365)',
		secured_yivi_attributes: 'Yivi Attributen',
		secured_attribute: 'Attribuut',
		secured_values: 'Waardes',
		secured_profile: 'Toon attribuut als badge in de room',
		ask_disclosure_title: 'Informatie verzoek',
		dm_user: 'Direct bericht',
		ask_disclosure_choose_user: 'Een gebruiker vragen informatie vrij te geven',
		ask_disclosure_user_title: 'Gebruiker',
		ask_disclosure_purpose_title: 'Promotie type',
		ask_disclosure_where_title: 'Waar openbaar maken',
		ask_disclosure_where_room_title: 'Openbaar het aan de kamer',
		ask_disclosure_where_room_placeholder: '!room:...',
		ask_disclosure_where_public: 'een openbare kamer',
		ask_disclosure_where_private: 'aan de steward',
		ask_disclosure_yivi_message: 'Een admin of steward heeft u gevraagd om de volgende waardes te delen',
		ask_disclosure_message_title: 'Bericht',
		ask_disclosure_message_placeholder: 'De volgende informatie aanvragen.',
		ask_disclosure_message_to_recipient: 'Aan {0}:\n\n{1}\n\nDe volgende informatie aanvragen: {2}',
		disclosure_sign_message: 'De gebruiker heeft de volgende informatie vrijgegeven:',
		disclosure_dialog_title: 'U bent gevraagd om wat informatie vrij te geven',
		disclosure_message: 'De attributen hieronder worden gedeeld aan de volgende kamer: {0}',
		disclose: 'Klik om vrij te geven',
		private_room: 'prive kamer',
		this_room: 'deze kamer',
		room_admin_success: 'Beheerder',
		room_admin_message: 'Gebruiker is nu kamerbeheerder',
		make_admin: 'Wil je jezelf tot beheerder van de kamer maken?',
		user_permission_message: 'Wil je de toestemming wijzigen?',
		permission_success: 'Toestemming succesvol gewijzigd',
		join_warning: 'Geen kamerbeheerders gevonden. Klik op "Doorgaan" om administratieve bevoegdheden voor deze kamer toe te wijzen',
		refresh_admin_operation: 'Ververs de pagina als de admin-badge niet wordt weergegeven.',
		user_perm_heading: 'Gebruikersrechten',
		user_perm_public_only: 'Rollen in openbare kamers; gesprekken staan er niet tussen.',
		user_perm_no_rooms: 'Deze gebruiker is geen lid van openbare kamers.',
		user_perm_room_admin_locked: 'Kamerbeheerders kunnen hier niet worden aangepast.',
		user_perm_saved: 'Opgeslagen',
		not_admin_perm_msg: 'Je moet kamerbeheerder zijn om de permissies te wijzigen. Permissie niet gewijzigd!',
		title_room: 'Kamer',
		title_room_join: 'Word lid van de kamer',
		title_permission: 'Toestemming',
		title_update: 'Update',
		title_user: 'Gebruiker',
		title_administrator: 'Beheerder',
		title_room_administrator: 'Kamer Beheerder',
		title_hub_administrator: 'Hub Beheerder',
		title_steward: 'Steward',
		title_room_steward: 'Kamer Steward',
		make_admin_confirm: 'Maak beheerder',
		join: 'Maak lid',
		reload: 'Herlaad',
		information: 'Informatie',
		join_admin_title: 'Maak lokale Admin lid',
		join_admin_text: 'Klik om de lokale Admin lid te maken',
		make_admin_title: 'Admin maken',
		make_admin_text: 'Maak jezelf Admin',
		flow_complete_title: 'Voltooid',
		flow_complete_text: 'Je bent nu Admin',
		support: 'Admin ondersteuning',
		remove_warning: 'Als je een waarde verwijdert of een nieuw attribuut toevoegt, moeten alle gebruikers de kamer opnieuw betreden',
		add_value: 'Voeg waarde toe',
		add: 'Voeg toe',
		add_tip: 'Gebruik "," om meerdere waardes tegelijk toe te voegen',
		editroom_typing: 'Selecteer hier het beveiligde attribuut dat je wilt controleren',
		value: 'Waardes',
		admin_contact_title: 'Contact hub beheerder',
		admin_contact_subtitle: 'Alleen voor hub-gerelateerde zaken',
		admin_contact_main_msg:
			'Voor kamergerelateerde vragen kunt u het beste eerst de kamersteward benaderen. De steward is te bereiken via het ledenpaneel in de kamer. De hub beheerder is alleen bedoeld voor hub-brede zaken of wanneer de steward niet kan helpen. Wilt u doorgaan?',
		if_admin_contact_not_present:
			'De Hub Beheerder is momenteel niet beschikbaar. Voor kamergerelateerde vragen kunt u de kamersteward bereiken via het ledenpaneel in de kamer.',
		rooms_you_moderate: 'Kamers die je modereert',
		you_suffix: '(jij)',
	},
	moderation: {
		admins: 'admins',
		yellow_card: 'gele kaart',
		yellow_card_info: 'je hebt een gele kaart ontvangen als waarschuwing voor deze kamer. reden: ',
		issue_yellow_card: 'geef een gele kaart',
		issue_yellow_card_info: 'het lid ontvangt een waarschuwing',
		revoke_yellow_card: 'gele kaart intrekken',
		red_card: 'rode kaart',
		red_card_info: 'je hebt een rode kaart ontvangen en kan deze kamer niet meer betreden. reden: ',
		issue_red_card: 'geef een rode kaart',
		issue_red_card_info: 'het lid wordt de toegang tot de kamer ontzegd',
		revoke_red_card: 'rode kaart intrekken',
		card_reason_label: 'reden voor het geven van deze kaart',
		sanctioned_members: 'gesanctioneerde leden',
		hidden_message: 'verborgen',
		hide_message: 'verbergen',
		hide_message_info: 'het geselecteerde bericht wordt verborgen met jouw reden als waarschuwing',
		hide_reason_label: 'reden voor het verbergen van dit bericht',
		remove_from_room: 'verwijder uit de kamer',
		remove_from_room_info: 'het lid {name} wordt uit deze kamer verwijderd',
		removed_from_room: 'je bent uit de kamer verwijderd, wil je opnieuw deelnemen?',
		kick_reason_label: 'reden voor het verwijderen van dit lid',
		kick_reason: 'reden',
		issue_timeout: 'geef een timeout',
		issue_timeout_info: 'voorkom tijdelijk dat {name} berichten kan versturen',
		revoke_timeout: 'timeout intrekken',
		timeout_hours: 'uren',
		timeout_minutes: 'minuten',
		timeout_reason_label: 'reden voor het geven van deze timeout',
		report_message: 'bericht rapporteren',
		report_message_info: 'rapporteer dit bericht bij de stewards van deze kamer',
		report_reason_label: 'reden voor het rapporteren van dit bericht',
		you_are_timed_out: 'timeout:',
		timeout_expires_in: 'verloopt over {time}',
		timeout_reason: 'reden',
		cannot_send_timed_out: 'je kunt geen berichten versturen tijdens een timeout',
		timed_out_members: 'leden met timeout',
		you_have_warning: 'waarschuwing:',
		dismiss_warning: 'verwijder',
		warned_members: 'gewaarschuwde leden',
		placeholder_timed_out: 'Je kunt niet typen tot de timeout is verstreken',
		placeholder_warning: 'Verwijder waarschuwing om te typen',
	},
	themes: {
		dark: 'Donker',
		light: 'Licht',
		system: 'Systeem',
	},
	timeformats: {
		format12: '12 uur',
		format24: '24 uur',
	},
	notifications: {
		allow: 'Aan',
		deny: 'Uit',
		notSupported: 'Deze browser ondersteunt geen meldingen.',
		promptAllow: 'Meldingen in je browser zijn geblokkeerd. Open de toestemmingen in je browser om PubHubs meldingen toe te staan.',
		promptReset: 'Om geen meldingen meer te krijgen, moet je je toestemming intrekken in de browservoorkeuren.',
		info: `Ga verder in je bowser: Klik op 'toestaan' in de pop-up op je scherm om PubHubs meldingen in je browser te krijgen.`,
		heading: 'Meldingen',
		dismiss: 'Verwijder',
		removed_from_secured_room:
			'Je bent verwijderd uit de beveiligde kamer {0} omdat {1} dagen zijn verlopen of iemand de kamer heeft aangepast; gebruik Yivi om je opnieuw aan te sluiten bij de kamer.',
		soon_removed_from_secured_room: 'Je wordt binnen {1} dagen verwijderd uit de beveiligde kamer {0}; gebruik Yivi om in de kamer te blijven.',
		rejoin: 'weer meedoen',
		rejoin_secured_room: 'Sluit je opnieuw aan',
	},
	onboarding: {
		house_rules: 'Huisregels {0}',
		welcome: 'Welkom bij de {0} hub!',
		welcome_description: 'Dit is je eerste bezoek. Leuk dat je er bent!',
		username_label: 'Kies een gebruikersnaam',
		username_description: 'Dit mag je eigen naam zijn, maar dat hoeft niet.',
		username_change_avatar: 'Kies een foto',
		username_disclaimer: 'Je kan je naam altijd nog aanpassen!',
		message_example: 'Zo zien jouw berichten er straks uit:',
		message_example_text: 'Wauw! Dat is cool!',
		consent_text: 'Ik heb de regels en privacy policy van de {0} hub doorgelezen en accepteer de voorwaarden.',
		enter_hub: 'Sla op en betreed de hub',
		welcome_consent: 'De huisregels van deze hub zijn gewijzigd',
		welcome_consent_description: 'Accepteer de voorwaarden opnieuw om de hub te betreden.',
		keep_pseudonym: 'Laat leeg om je pseudoniem {0} te houden.',
		step: 'Stap {0} van {1}',
		submit_error: 'Er ging iets mis bij het opslaan. Probeer het opnieuw.',

		info_abt_pseudonym: 'Deze hub heeft je een willekeurige naam gegeven (pseudonym)',
		info_issue_identity:
			'Dit pseudonym verbergt om privacyredenen je identiteit. Maar voor anderen in de hub is het niet zo handig. Je kunt zelf een naam kiezen die anderen in de hub zien',
		info_abt_nickname_use: 'Houd er rekening mee dat andere deelnemers ook zelfgekozen namen kunnen gebruiken die niet hun echte naam hoeven te zijn.',
		info_abt_choose_later: 'Je kunt ook later een naam kiezen of deze opnieuw wijzigen.',
		info_abt_yivi_room:
			'Voor bepaalde kamers in deze hub kan het zijn dat je wordt gevraagd (een deel van) je identiteit bekend te maken, via de Yivi app. Dit geeft deelnemers in die ruimtes zekerheid over elkaar.',
		info_misbehave: 'Als je je misdraagt, kun je uiteindelijk van deze hub worden verbannen.',
		continue: 'Doorgaan',
		success_msg: 'Je kunt de kamers verkennen en chatten met de community!',
		later: 'Je hebt je naam in deze hub nog niet gekozen. Je kunt dit later alsnog doen.',
		update: 'Naam bijgewerkt',
		nickname_placeholder: 'Type hier je geozen naam ...',
	},
	message: {
		send: 'Verstuur',
		in_reply_to: 'Antwoord op:',
		editing: 'Bericht aanpassen',
		edited: 'Aangepast',
		edited_at: 'Aangepast {datetime}',
		notification: 'Nieuw bericht in hub',
		upload_file: 'Upload',
		reply: 'Antwoord',
		reply_in_thread: 'Antwoord in thread',
		view_thread: 'Bekijk thread ({count} antwoord) | Bekijk thread ({count} antwoorden)',
		whisper_to: 'Fluister naar',
		whisper_visible_only_to: 'Fluister alleen zichtbaar voor',
		only_visible_to_you: 'Alleen zichtbaar voor jou',
		reply_emoji: 'Reageer snel',
		emoji_picker: 'Emoji',
		quick_reactions: 'Snelle reacties',
		react_with: 'Reageer met {emoji}',
		reaction_toggle: 'Reageer met {emoji}, {count} tot nu toe',
		more_reactions: 'Meer reacties',
		context_menu: 'Meer acties',
		scheduler: 'Datumprikker',
		poll: 'Peiling',
		videocall: 'Videogesprek',
		announcement_mode: 'Aankondiging',
		announcement_placeholder: 'Aankondiging',
		enable_announcement: 'Aankondiging',
		disable_announcement: 'Aankondigingsmodus uitschakelen',
		scheduler_closed: 'Deze datumprikker is gesloten. Je kunt niet meer stemmen.',
		pick_option: 'Kies een datum',
		close: 'Sluiten',
		reopen: 'Heropenen',
		edit: 'Bewerk',
		pick: 'Kies',
		sign: {
			add_signature: 'Ondertekenen',
			heading: 'Een bericht ondertekenen',
			info: 'Laat zien dat je achter dit bericht staat door het te ondertekenen met jouw gegegevens.',
			warning: 'Een ondertekend bericht kan worden gedeeld. Zet er geen persoonlijke informatie in en denk aan de medegebruikers in deze kamer.',
			selected_attributes: 'Met deze informatie onderteken jij je bericht:',
			signed_message_email: 'Ondertekend bericht (e-mail)',
			signed_message_tooltip: 'Je bericht wordt ondertekend met je e-mailadres, zodat anderen kunnen verifiëren dat het van jou afkomstig is.',
			send: 'Onderteken & verstuur',
			edit: 'Onderteken & bewerk',
		},
		messageSigned: {
			heading: 'Ondertekend bericht',
			info: 'Een bericht dat ondertekend is met Yivi attributen.',
			verificationStatus: 'Ondertekende berichten zijn nog in ontwikkeling. Ze zijn betrouwbaar, maar worden nog niet cryptographisch geverifieerd.',
		},
		delete: {
			cannot_undo: 'Je kan dit niet terugdraaien.',
			heading: 'Bericht verwijderen?',
			user: 'verwijderde gebruiker',
			beware: 'Let op!',
			file_not_deleted:
				'Je bericht is na het verwijderen niet meer zichtbaar voor anderen, maar het bestand kan nog steeds gedownload worden door gebruikers die de link hebben opgeslagen.',
			original_message_deleted: 'Oorspronkelijk bericht verwijderd',
			message_deleted: 'Verwijderd bericht',
			message_removed_by_steward: 'Bericht verwijderd door steward',
			reason: 'Reden',
			reason_label: 'Reden voor het verwijderen van dit bericht (zichtbaar voor de auteur)',
		},
		voting: {
			add_option: 'Voeg keuze toe',
			creating_option: 'Bezig keuze aan te maken...',
			title: 'Titel',
			description: 'Omschrijving',
			option: 'Keuze',
			option_number: 'Keuze {number}',
			location: 'Locatie',
			enter_title: 'Geef een titel...',
			enter_option: 'Geef een keuze...',
			enter_description: 'Geef omschrijving...',
			enter_location: 'Geef locatie...',
			allow_multiple_answers: 'Meerder antwoorden mogelijk',
			show_votes_before_voting: 'Stemmen laten zien',
			show_votes: 'Laat stemmen zien',
			hide_votes: 'Verberg stemmen',
			plural_votes: 'stem|stemmen',
			edited: 'aangepast',
		},
		threads: {
			view_thread: 'bekijk thread',
		},
		forum: {
			add_new_thread: 'Maak nieuw bericht',
			edit_thread: 'Bewerk bericht',
			no_threads: 'Nog geen berichten',
			all_posts: 'Alle berichten',
			comments: 'Reacties',
			no_comments: 'Nog geen reacties, reageer als eerste',
			show_replies: 'Toon reacties ({0})',
			hide_replies: 'Verberg reacties',
			upvote: 'Omhoog stemmen',
			downvote: 'Omlaag stemmen',
			sort_trending: 'Trending',
			sort_newest: 'Nieuwste',
			sort_top: 'Top',
			title: 'Titel',
			description: 'Omschrijving',
			help_title: 'Geef je bericht een korte, duidelijke titel',
			help_description: 'Introduceer je onderwerp en licht je bericht toe',
		},
	},
	time: {
		today: 'Vandaag',
		yesterday: 'Gisteren',
		daysago: '{0} dagen geleden',
	},
	emoji: {
		clock: 'Alles',
		smiley: 'Smileys & mensen',
		bear: 'Dieren & natuur',
		cup: 'Eten & drinken',
		basketball: 'Reizen & plaatsen',
		house: 'Activiteiten',
		lightbulb: 'Levensstijl',
		signs: 'Symbolen',
		flag: 'Vlaggen',
	},
	validation: {
		required: '{0} is een verplicht veld',
		max_length: '{0} is te lang , er mogen maximaal {1} karakters zijn, maar er zijn {2} ',
		min_length: '{0} is te kort, er moeten minimaal {1} karakters zijn, maar er zijn {2}',
		max_items: 'Te veel {0}, er mogen maximaal {1} items zijn, maar er zijn {2}',
		min_items: 'Te weinig {0}, er moeten minimaal {1} items zijn, maar er zijn {2}',
		max_value: '{0} is te hoog, de maximale waarde is {1}',
		min_value: '{0} moet minimaal een waarde van {1} hebben',
		is_number: '{0} moet een getal zijn',
	},
	bubble: {
		organize: 'Organiseer je hubs door ze te slepen.',
	},
	roomlibrary: {
		library: 'Bestanden',
		search: 'Zoek bestanden',
		empty: 'Nog geen bestanden',
		empty_hint: 'Upload bestanden om ze te delen met iedereen in deze kamer.',
		file_count: '0 bestanden (max. {max}) | 1 bestand (max. {max}) | {count} bestanden (max. {max})',
		select: 'Selecteer',
		select_all: 'Selecteer alles',
		delete_selected: 'Verwijder',
		drop_to_upload: 'Laat bestanden los om ze te uploaden',
		library_full: 'Deze kamer heeft al het maximum van {0} bestanden. Verwijder bestanden om ruimte te maken.',
		files_skipped: 'Niet alle bestanden zijn toegevoegd: een kamer kan maximaal {0} bestanden bevatten.',
		upload_waiting: 'Wachten',
		uploading: 'Uploaden {0}%',
		upload_done: '{0} geüpload',
		upload_failed: 'Uploaden van {0} mislukt',
		sign_error: 'Bestand {0} kon niet worden voorbereid om te ondertekenen. Probeer het opnieuw.',
		sort: {
			label: 'Sorteren',
			newest: 'Nieuwste eerst',
			oldest: 'Oudste eerst',
			name_asc: 'Naam A tot Z',
			name_desc: 'Naam Z tot A',
			largest: 'Grootste eerst',
			uploader: 'Uploader',
		},
		signed: 'Ondertekend door',
		signed_info: 'Ondertekend met',
		used_attribute: 'Gebruikt attribuut',
		with_value: 'met waarde',
		sign_file_hash: 'Je staat op het punt de hash van het bestand te ondertekenen',
		sign_file: 'Onderteken dit bestand',
		file_details: 'Bestandsgegevens',
		delete_file: 'Verwijder bestand',
		share_to_timeline: 'Deel in het gesprek',
		check_file_hash: 'Controleer of de hash in de Yivi-app hetzelfde is.',
		download_info: 'Download ondertekening',
		selected_files: '0 | 1 bestand geselecteerd | {count} bestanden geselecteerd',
		delete: {
			heading: 'Bestand permanent verwijderen?',
			content: 'Je staat op het punt het bestand {0} te verwijderen. <p class="font-bold">Pas op! Je kunt dit niet ongedaan maken.</p>',
			multiple_heading: 'Bestanden permanent verwijderen?',
			multiple_content: 'Je staat op het punt {0} bestanden te verwijderen. <p class="font-bold">Pas op! Je kunt dit niet ongedaan maken.</p>',
			failed: 'Bestand {0} kon niet worden verwijderd. Probeer het opnieuw.',
			multiple_failed: 'Niet alle bestanden konden worden verwijderd. Probeer het opnieuw.',
		},
		info: {
			name: 'Naam',
			filesize: 'Grootte',
			filetype: 'Type',
			sign: 'Ondertekend',
			uploaded_by: 'Geüpload door',
			uploaded_on: 'Geüpload op',
			type: 'Type:',
			size: 'Grootte: {0} kb',
			smallsize: '{0} kb',
		},
	},
	attribute: {
		heading: 'Attributen:',
		pbdf: {
			'sidn-pbdf': {
				email: {
					email: 'e-mail',
					domain: 'e-mail domein',
				},
				mobilenumber: {
					mobilenumber: 'telefoonnummer',
				},
			},
			gemeente: {
				address: {
					street: 'straat',
					houseNumber: 'huis nummer',
					zipcode: 'postcode',
					city: 'stad',
					municipality: 'gemeente',
				},
				personalData: {
					fullname: 'volledige naam',
					firstnames: 'voornaam',
					surname: 'achternaam',
					dateofbirth: 'geboortedatum',
					gender: 'gender',
					over12: 'ouder dan 12',
					over16: 'ouder dan 16',
					over18: 'ouder dan 18',
					over21: 'ouder dan 21',
					over65: 'ooduer dan 65',
				},
			},
			pbdf: {
				'surfnet-2': {
					institute: 'surf instituut',
					type: 'surf type',
					id: 'surf id',
					fullname: 'surf volledige naam',
					firstname: 'surf voornaam',
					familyname: 'surf achternaam',
					email: 'surf e-mail',
				},
			},
		},
	},
	videocall: {
		appear_as: 'Je verschijnt als',
		chat: 'Chat',
		devices: 'Apparaten',
		disable_camera: 'Camera uitzetten',
		duration: 'Duur',
		e2ee_blocked_body:
			'Videogesprekken zijn end-to-end versleuteld, en deze browser of sessie kan ze niet versleutelen. Probeer een recente versie van Chrome, Firefox of Safari, en zorg dat de site gegevens mag opslaan.',
		e2ee_blocked_title: 'Versleutelde gesprekken zijn hier niet beschikbaar',
		enable_camera: 'Camera aanzetten',
		exit: 'Sluiten',
		exit_fullscreen: 'Volledig scherm sluiten',
		fullscreen: 'Volledig scherm',
		fullscreen_tooltip: 'Volledig scherm in-/uitschakelen (Shift+F)',
		hide_self_view: 'Verberg je eigen beeld',
		join: 'Deelnemen',
		join_button: 'Neem deel aan videogesprek',
		join_tooltip: 'Neem deel aan videogesprek',
		leave_call: 'Gesprek verlaten',
		message_preview: 'Videogesprek',
		microphone_source: 'Microfoon',
		mute_for_me: 'Dempen voor mij',
		mute_microphone: 'Microfoon dempen',
		no_camera: 'Geen camera',
		no_microphone: 'Geen microfoon',
		no_speaker: 'Geen luidspreker',
		nobody_here: 'Nog geen andere deelnemers',
		participants: 'Deelnemers',
		participants_count: 'Deelnemers ({count})',
		permission_denied_body: 'PubHubs kan je microfoon of camera niet bereiken. Geef toegang via je browserinstellingen en vernieuw daarna de apparaten.',
		permission_denied_title: 'Toegang geblokkeerd',
		permission_pending_body: 'Je browser vraagt of PubHubs je microfoon en camera mag gebruiken. Kies toestaan om verder te gaan.',
		permission_pending_title: 'Geef toegang',
		permission_screenshare_body:
			'Je browser heeft geen scherm doorgegeven om te delen. Kies een venster of scherm wanneer erom gevraagd wordt, of geef je browser toestemming om het scherm op te nemen in je systeeminstellingen.',
		permission_screenshare_title: 'Scherm delen is niet gestart',
		permission_unavailable_body:
			'We konden geen microfoon of camera vinden op dit apparaat. Sluit er een aan en vernieuw de apparaten, of neem deel om alleen te kijken en te luisteren.',
		permission_unavailable_title: 'Geen apparaten gevonden',
		prejoin_title: 'Videogesprek starten',
		refresh_devices: 'Apparaten vernieuwen',
		self_label: 'Jij',
		show_self_view: 'Toon je eigen beeld',
		speaker_source: 'Luidspreker',
		state: {
			started: 'Videogesprek begonnen',
			joined: 'Is erbij gekomen',
			left: 'Heeft het gesprek verlaten',
			ended: 'Videogesprek beëindigd',
			startedended: 'Videocall begonnen',
		},
		start_button: 'Start videogesprek',
		start_screen_share: 'Deel je scherm',
		start_tooltip: 'Start videogesprek',
		stop_screen_share: 'Stop met je scherm delen',
		undecryptable: 'Kan deze video niet ontsleutelen',
		unmute_for_me: 'Dempen opheffen voor mij',
		unmute_microphone: 'Microfoon aanzetten',
		video_source: 'Camera',
		you: '(jij)',
	},
	roles: {
		details: 'Rol details',
		room: 'Kamer',
		type: 'Type',
		status: 'Status',
		search: 'Zoek rollen',
		empty: 'Geen rollen of stewards gevonden',
		refresh: 'Vernieuwen',
		load_more: 'Meer laden',
		loading_more: 'Laden...',
		new_invitation: 'Nieuwe uitnodiging',
		select_placeholder: 'Selecteer een item uit de lijst voor meer details',
		// Types
		type_steward_invitation: 'Steward uitnodiging',
		type_expert_invitation: 'Expert uitnodiging',
		type_steward: 'Steward',
		type_expert: 'Expert',
		type_information: 'Informatie',
		// Status
		status_disclosed: 'Vrijgegeven',
		status_pending: 'In afwachting',
		// Filters
		filter_invitations: 'Uitnodigingen',
		filter_stewards: 'Stewards',
		filter_experts: 'Experts',
		// Attributes
		disclosed_attributes: 'Vrijgegeven attributen',
		// Actions
		promote_to_steward: 'Promoveer tot steward',
		promote_to_expert: 'Promoveer tot expert',
		reject_invitation: 'Wijs uitnodiging af',
		demote_steward: 'Degradeer steward',
		remove_expert: 'Verwijder expert',
		// Confirmations
		promote_steward_confirm: 'Weet je zeker dat je {name} wilt promoveren tot steward?',
		promote_expert_confirm: 'Weet je zeker dat je {name} wilt promoveren tot expert?',
		reject_confirm: 'Weet je zeker dat je de uitnodiging voor {name} wilt afwijzen?',
		demote_confirm: 'Weet je zeker dat je {name} wilt degraderen als steward?',
		remove_expert_confirm: 'Weet je zeker dat je de expertstatus van {name} wilt verwijderen?',
	},
	expert: {
		title: 'Expert',
		expert: 'Expert',
		verify_message: 'Beoordeel bericht',
		edit_assessment: 'Bewerk beoordeling',
		remove_verification: 'Verwijder beoordeling',
		assess_message: 'Beoordeel dit bericht',
		verify_message_info: 'Als expert kun je dit bericht verifiëren',
		verify_message_description: 'Je beoordeelt dit bericht met je referenties: {credentials}.',
		verify_sign_info: 'Je ondertekent deze beoordeling met je volledige naam via Yivi.',
		add_context_label: 'Voeg context toe',
		verify: 'Verifieer',
		sign_and_verify: 'Onderteken en verifieer',
		sign_and_submit: 'Onderteken en verstuur',
		scan_to_sign: 'Scan om te ondertekenen',
		scan_to_sign_description: 'Scan de QR-code met de Yivi-app om deze beoordeling te ondertekenen met je volledige naam.',
		verification_signature_message: 'Expertbeoordeling voor bericht {eventId} met referenties: {credentials}. Notitie: {note}',
		no_note: 'Geen notitie toegevoegd',
		// Verification type labels
		verification_type_label: 'Wat is je beoordeling?',
		type_verified: 'Verifiëren',
		type_verified_description: 'Deze informatie is juist',
		type_falsified: 'Weerleggen',
		type_falsified_description: 'Deze informatie is onjuist',
		type_context: 'Context toevoegen',
		type_context_description: 'Voeg nuance of extra informatie toe',
		// Status messages per type
		verified_by: 'Geverifieerd door {expert}',
		verified_and_signed_by: 'Geverifieerd en ondertekend door {expert}',
		falsified_by: 'Weerlegd door {expert}',
		falsified_and_signed_by: 'Weerlegd en ondertekend door {expert}',
		context_by: 'Context toegevoegd door {expert}',
		context_and_signed_by: 'Context toegevoegd en ondertekend door {expert}',
		assessed_at: 'Beoordeeld op {date}',
		verified_at: 'Geverifieerd op {date}',
		assign_expert: 'Wijs expertstatus toe',
		assign_expert_confirm: 'Expertstatus toewijzen aan {user}?',
		assign_expert_note: 'Deze gebruiker kan berichten in deze kamer beoordelen. Ze moeten eerst hun expertprofiel met referenties instellen.',
		remove_expert: 'Verwijder expertstatus',
		// Profile
		edit_profile: 'Expertprofiel',
		profile_description: 'Stel je expertreferenties in. Deze worden getoond wanneer je berichten beoordeelt.',
		profile_required: 'Expertprofiel vereist',
		profile_required_description:
			'Je moet eerst je expertprofiel instellen voordat je berichten kunt beoordelen. Je profiel bevat je referenties en andere informatie die wordt getoond wanneer je berichten beoordeelt.',
		set_profile: 'Profiel instellen',
		credentials: 'Referenties',
		specializations: 'Specialisaties (komma-gescheiden)',
		institution: 'Instelling',
		// Display labels
		credentials_label: 'Referenties:',
		specializations_label: 'Specialisaties:',
		note_label: 'Notitie:',
		sources_label: 'Bronnen (één per regel)',
		sources_display_label: 'Bronnen:',
		source_placeholder: 'https://voorbeeld.nl/bron',
		// Failures
		verify_failed: 'Je beoordeling kon niet worden verzonden. Probeer het opnieuw.',
		remove_verification_failed: 'Je beoordeling kon niet worden verwijderd. Probeer het opnieuw.',
		profile_save_failed: 'Je expertprofiel kon niet worden opgeslagen. Probeer het opnieuw.',
	},
};

export { nl };
